export default "__VITE_ASSET__DqU4M5x5__"